// extracted by mini-css-extract-plugin
export var dropdownButton = "_3a-0";
export var fullWidthDropdownButton = "_3a-1";
export var icon = "_3a-3";
export var iconPlaceholder = "_3a-2";
export var menuItemRow = "_3a-9";
export var separator = "_3a-e";
export var shortcutContainer = "_3a-7";
export var shortcutContainerFilled = "_3a-8";
export var shortcutIconLg = "_3a-6";
export var shortcutIconMd = "_3a-5";
export var shortcutIconSm = "_3a-4";
export var submenuChevron = "_3a-d";
export var submenuDropdown = "_3a-a";
export var submenuTriggerRow = "_3a-b";
export var submenuTriggerRowOpen = "_3a-c";